/**
 * Workflows P5-7: the Verify e-mail step (`verify_email`). Merged into `engage.workflows` (steps, summaries, exits, fields,
 * builder.channelNotes.steps, runs and analysis.outcomes).
 */
export const workflowsVerify = {
  steps: { verify_email: "Verify e-mail" },
  summaries: { verify_email: "Sends a code to the known e-mail · {{message}}" },
  exits: { verified: "Verified", verificationFailed: "Not verified" },
  fields: {
    verifyIntro: "Message before the code",
    verifyIntroHint: "Shown with the Send code button. The code, the masked address and the buttons are added for you.",
    verifyCollectFirst: "This step needs the visitor's e-mail to be known. Collect it first with a Collect data step that saves to the visitor's e-mail, or the step takes its Not verified path.",
    verifiedGoTo: "When the code is right, go to",
    verifiedHint: "The visitor's e-mail is marked verified, so the “Visitor is verified” condition is true from here on.",
    failedGoTo: "When it can't be verified, go to",
    failedHint: "No e-mail known, wrong codes, an expired code, messages that are not a code, or too many codes asked for the address.",
    verifyHow: {
      title: "How it works",
      address: "The visitor gets a {{digits}}-digit code at the e-mail address the workflow already knows.",
      lifetime: "The code works for {{minutes}} minutes and only once.",
      failures: "{{wrong}} wrong codes, {{other}} messages that are not a code, or an expired code take the Not verified path.",
      resend: "“Resend code” opens {{seconds}} seconds after the first code, once.",
      verified: "A correct code marks the visitor's e-mail verified. Nobody is signed in and no audience changes.",
      preview: "In the Playground nothing is e-mailed: type {{code}} to continue.",
    },
  },
  builder: {
    channelNotes: {
      steps: {
        verify_email: {
          web: "Web chat, web app and mobile: the visitor taps “Send code”, which is checked for bots, then types the code in the chat box.",
          messenger: "Messenger: the code is e-mailed as soon as the step is reached (no bot check, only rate limits). The visitor types the code, or RESEND after a minute.",
          email: "E-mail: the code goes to the known address as soon as the step is reached. The visitor replies with the code above the quoted text.",
          api: "Visitor-facing steps do not run on the developer API channel.",
          preview: "Playground: nothing is e-mailed. The code is 123456 and nothing is written to the visitor.",
        },
      },
    },
  },
  runs: {
    endedReasons: { verification_failed: "The e-mail could not be verified." },
    reasons: {
      no_email: "No e-mail address known",
      expired: "The code expired",
      too_many_attempts: "Too many wrong codes",
      not_a_code: "Messages that were not a code",
      rate_limited: "Too many codes asked for the address",
      send_failed: "The code could not be sent",
      blocked: "The contact record is blocked",
      unavailable: "Verification was unavailable",
    },
  },
  analysis: { outcomes: { verified: "Verified", failed: "Not verified", expired: "Code expired" } },
};
